import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { FaJira } from 'react-icons/fa';
import { CheckCircle, Target } from 'lucide-react';
import { GitHub } from '@mui/icons-material';

const IntegrationItem = ({ icon: Icon, label, statusLabel, isConnected, iconSize = 24 }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
    }}
  >
    <Typography
      variant="body2"
      sx={{
        color: '#737373',
        fontSize: '0.875rem',
        fontWeight: 500,
      }}
    >
      {label}
    </Typography>
    <Box
      sx={{
        bgcolor: '#F1F5F9',
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Icon
        size={iconSize}
        style={{ color: '#737373', fontSize: '1.2rem' }}
      />
    </Box>
    <Chip
      icon={<CheckCircle size={16} />}
      label={statusLabel}
      size="small"
      sx={{
        bgcolor: '#fff',
        color: '#737373',
        fontSize: '0.75rem',
        gap: 1,
        height: 24,
        '& .MuiChip-icon': {
          color: '#737373',
        },
        '& .MuiChip-label': {
          px: 1,
        },
      }}
    />
  </Box>
);

const IntegrationsSection = ({ project }) => {
  const scmConnected = !!project.repository_config?.token;
  const aiConnected = !!project.analyzer_config?.api_key;
  const jiraEnabled = !!project.jira_enabled;

  const integrations = [
    {
      icon: GitHub,
      label: 'SCM',
      isConnected: scmConnected,
      statusLabel: scmConnected ? 'Connected' : 'Not Set',
      iconSize: 18,
    },
    {
      icon: Target,
      label: 'AI',
      isConnected: aiConnected,
      statusLabel: aiConnected ? 'Configured' : 'Not Set',
      iconSize: 18,
    },
    {
      icon: FaJira,
      label: 'JIRA',
      isConnected: jiraEnabled,
      statusLabel: jiraEnabled ? 'Enabled' : 'Disabled',
      iconSize: 18,
    },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ display: 'flex', gap: 6 }}>
        {integrations.map((integration, index) => (
          <IntegrationItem
            key={index}
            icon={integration.icon}
            label={integration.label}
            statusLabel={integration.statusLabel}
            isConnected={integration.isConnected}
            iconSize={integration.iconSize}
          />)
        )}
      </Box>
    </Box>
  );
};

export default IntegrationsSection;
